'use client';

export default function FulfillmentPopup(docUrl: string | undefined) {
  const getRandomNumber = (min: number, max: number) => {
    return Math.random() * (max - min) + min;
  };
  if (typeof window !== 'undefined') {
    let width = 0.8 * window.innerWidth;
    width = width < 800 ? 800 : width;
    let height = 0.8 * window.innerHeight;
    height = height < 600 ? 600 : height;
    const top = screen.height / 2 - height / 2;
    const left = screen.width / 2 - width / 2;
    let params = 'width=' + width + 'px';
    params += ',height=' + height + 'px';
    params += ',top=' + top + 'px';
    params += ',left=' + left + 'px';
    params += ',scrollbars=1';
    return window.open(`${docUrl}`, 'fulfilmentAsset' + getRandomNumber(1, 100), params);
  }
}